export const RTL_LOCALES = ['ar', 'he', 'fa', 'ur'];

export const rtlDirectionForLocale = (locale: string) => {
  return RTL_LOCALES.includes(locale) ? 'rtl' : 'ltr';
};
